module.exports = __webpack_public_path__ + "img/white_logo.texty.c4abc7de.svg";